import { FrameworkContext } from 'global/cnr/contexts/FrameworkContent';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import UiSaveButtons from 'global/components/buttons/UiSaveButtons';
import { appUserLevels } from 'global/enums/globalEnums';
import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { Icon, Label, Segment } from 'semantic-ui-react';
import { uniqueKey } from '../../../global/common/keys';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import { _allowGolfEventUpdates } from '../cnr/reducers/GolfEventReducer';
import GolferAdd from './GolferAdd';
import GolferRow, { golferRowTypes, handicapModes } from './GolferRow';
import usePageNavigation from 'global/cnr/contexts/useHelpers/usePageNavigation';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import { useGolf } from '../useHelpers/useGolf';
import { GolfTournamentContext } from '../cnr/contexts/GolfTournamentContext';
import { useGolfers } from '../useHelpers/useGolfers';

export const golfersModes = {
  event: 'event',
  tournament: 'tournament',
  tournamentChange: 'tournamentChange',
  tournamentRecord: 'tournamentRecord',
}

export const golferTeamModes = {
  all: 'all',
  team1: 'team1',
  team2: 'team2',
}

export const golferTournamentHeaderModes = {
  handicaps: 'handicaps',
  courseHandicaps: 'courseHandicaps',
  records: 'records',
  opponents: 'opponents',
}

export const golferEventHeaderModes = {
  records: 'records',
  opponents: 'opponents',
}

export const golferTournamentHeaderModes_admin = {
  ...golferTournamentHeaderModes,
  add: 'add'
}

export const golferEventHeaderModes_admin = {
  ...golferEventHeaderModes,
  add: 'add'
}

const _getPlayerRecords = true


const Golfers = (props) => {

  const { golfersMode } = props ?? {}

  const upn = usePageNavigation()
  const { get_golfCourseStats } = useGolf()
  const { update_golfHandicapRecommendations, handleUpdate_tournamentGolfersHandicaps } = useGolfers()

  const parentContext = useContext(ParentContext)
  const { fns: fns_parents } = parentContext ?? {}
  const { appUser_fns } = fns_parents

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { currentSwiperTab } = framework_state ?? {}

  const allowMods = appUser_fns.validateAccess_item(appUserLevels.superAdmin, true)

  // golfParentContext 
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states, handlers, fns } = golfParent_contexts ?? {}
  const { paps_state, item_state, golfEvent_state, golfTournament_state } = states ?? {}
  const { header_handlers, golfTournament_handlers } = handlers ?? {}

  const golfTournamentContext = useContext(GolfTournamentContext)
  const { golfTournament_state: gts } = golfTournamentContext ?? {}

  const appUserAccess = useAppUserAccess()
  const { isSuperAdminDeveloper } = appUserAccess ?? {}

  const { handleSubCaption } = header_handlers ? header_handlers : {}

  // uiItemContext 
  const { vldSorted: athletes } = item_state ?? {}
  const { pathViews } = paps_state ?? {}

  // pageContext   
  // golfEventContext  
  const { golfers: golfers_event, teams } = golfEvent_state ?? {}

  console.log('golfers_event', golfers_event)

  // golfTournamentContext  
  const { details, golfers: golfers_tournament, golferRecords, tournamentGolfCourses } = golfTournament_state ?? {}
  const { teams: teams_tournament } = details ?? {}

  const [_golfers, set_golfers] = useState()
  const [handicapMode, setHandicapMode] = useState(handicapModes.event)
  const [golferTeamMode, setGolferTeamMode] = useState(golferTeamModes.all)
  const [golferHeaderMode, setGolferHeaderMode] = useState(golferTournamentHeaderModes.handicaps)
  const [showAddGolfer, setShowAddGolfer] = useState()
  const [currentGolfer, setCurrentGolfer] = useState()
  const [thisUpdated, setThisUpdated] = useState()
  const [updating, setUpdating] = useState()
  const [showPaste, setShowPaste] = useState()
  const [golfer_partners, setGolfer_partners] = useState()

  let cn = 'golfers-container ' + handicapMode

  const ammendGolfers = (glf_updated) => {
    let glfs;
    if (pathViews.tournamentTeams) {
      glfs = golfers_tournament
      if (pathViews.tournamentTeams) {
        glfs = _.filter(glfs, { teamNumber: parseInt(pathViews.tournamentTeams) })
      }
      setHandicapMode(handicapModes.tournament)
    } else if (pathViews.golfTournaments) {
      switch (golferHeaderMode) {
        case golferTournamentHeaderModes.records:
        case golferTournamentHeaderModes.opponents:
          glfs = golferRecords
          break;
        case golferTournamentHeaderModes.partners:
          glfs = golfer_partners
          break;
        default:
          glfs = glf_updated || golfers_tournament
          break;
      }
      if (pathViews.tournamentTeams) {
        glfs = _.filter(glfs, { teamNumber: parseInt(pathViews.tournamentTeams) })
      }
      setHandicapMode(handicapModes.tournament)
    } else if (pathViews.events) {
      glfs = golfers_event
      setHandicapMode(handicapModes.event)
    } else {
      glfs = athletes
    }

    if (golfersMode === golfersModes.tournamentChange) {
      glfs = golfers_event
      Object.keys(golfers_tournament).forEach(gtkey => {
        if (glfs[gtkey]) { delete glfs[gtkey] }
      })
    }
    set_golfers(glfs)
  }

  useEffect(() => {
    if (allowMods) {
      framework_handlers.handleAdd_navigationItem('ammendHandicaps', { icon: 'edit', caption: _.startCase('ammendTournamentHandicapIndexes'), oc: handleAmmendThi, activeTabOnly: 'tournamentGolfers' });
      framework_handlers.handleAdd_navigationItem('addGolfer', { icon: 'add', caption: _.startCase('addGolfer'), oc: handleClick_addGolfer, activeTabOnly: 'tournamentGolfers' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentSwiperTab]);

  useEffect(() => {
    const team = teams_tournament ? teams_tournament['team' + pathViews.tournamentTeams] : null
    const { name } = team ?? {}
    if (name) { handleSubCaption(name) }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [teams_tournament]);

  useEffect(() => {
    const gc = tournamentGolfCourses && Object.values(tournamentGolfCourses)[0]
    if (gc) {
      update_golfHandicapRecommendations({ golfers: golfers_tournament, golfCourse: gc })
    }
    ammendGolfers(golfers_tournament)
    const gcs = get_golfCourseStats({ golfCourse: gc })
  }, [golfers_tournament, golfers_event, golferHeaderMode]);

  const handleClick_teamHeader = (golfersTeamMode) => setGolferTeamMode(golfersTeamMode)
  const handleClick_golferHeader = (golfersHeaderMode) => setGolferHeaderMode(golfersHeaderMode)
  const handleClick_addGolfer = () => setShowAddGolfer(!showAddGolfer)

  const handleClick_golferRow = (item) => {
    const { _itemKey } = item ?? {}
    if (pathViews.golfTournaments) {
      upn.handleNav_item({ key: 'tournamentGolfers' }, _itemKey)
    } else {
      upn.handleNav_item({ key: 'golfers' }, _itemKey)
    }
  }

  const lbl = (value, index) => <Label
    // key={uniqueKey('glfl', index)}
    size={'tiny'}
  >{value}
  </Label>

  const hcpLabelGroup = () => {
    let cn = 'golfer-hcps label-group'
    let lbls = []
    switch (handicapMode) {
      case handicapModes.event:
        lbls = [
          lbl('S', 2),
          lbl('H.I.', 3),
        ]
        cn += ' l3'
        break;

      case handicapModes.tournament:
        switch (golferHeaderMode) {
          case golferTournamentHeaderModes.opponents:
          case golferTournamentHeaderModes.partners:
            lbls = []
            break;
          case golferTournamentHeaderModes.records:
            lbls = []
            break;
          default:
            lbls = [
              // lbl('App', 2),
              lbl('THI', 3),
              // lbl('RCH', 4),
              lbl('CH', 4)
            ]
            break;
        }
        cn += ' l4'
        break;

      default:
      // nothing
    }
    return <div key={uniqueKey('glfh')} className={cn}>{lbls}</div>
  }

  const golferRow_header = () => {
    const h = ['#', '', 'Name']
    const his = h.map((hi, index) => (<div key={uniqueKey('glfh', index)}  >{hi}</div>))
    his.push(hcpLabelGroup())
    return <div key={uniqueKey('glfh')} className={'golfer-row hdr'}>{his}</div>
  }

  const golferRow = (golfer, index) => <GolferRow
    key={uniqueKey('glf', index)}
    golferRowType={golferRowTypes.single}
    golfersMode={golfersMode}
    golferHeaderMode={golferHeaderMode}
    golfer={golfer}
    index={index}
    handicapMode={handicapMode}
    handleClick={handleClick_golferRow}
    ammendGolfers={ammendGolfers}
  />

  const golferRows = () => {
    const _orderBy = golferHeaderMode === golferTournamentHeaderModes.records ? ['points', 'lastName', 'firstName'] : ['lastName', 'firstName']
    const _desc = golferHeaderMode === golferTournamentHeaderModes.records ? ['desc', 'asc', 'asc'] : ['asc', 'asc']
    const glfs = _golfers ? _.orderBy(_golfers, _orderBy, _desc) : []
    if (glfs && glfs.length > 0) {
      return glfs.map((golfer, index) => (golferRow(golfer, index)))
    } else {
      return 'None'
    }
  }

  const header_teams = () => {
    const oc = (item) => { handleClick_teamHeader(item) }
    return <ItemMenuSquares
      menuItems={golferTeamModes}
      activeItem={golferTeamMode}
      imsType={_imsTypes.menu}
      onClick={oc}
    />
  }

  const header_menu = () => {
    const oc = (item) => { handleClick_golferHeader(item) }
    return <ItemMenuSquares
      menuItems={isSuperAdminDeveloper ? golferTournamentHeaderModes_admin : golferTournamentHeaderModes}
      activeItem={golferHeaderMode}
      imsType={_imsTypes.menu}
      onClick={oc}
    />
  }

  const content = () => <div className={cn}>
    {golferRow_header()}
    {golferRows()}
  </div>

  const footer_golfers = () => {

    const btns = []

    switch (handicapMode) {
      case handicapModes.tournament:
        if (thisUpdated) {
          btns.push({ oc: handleSaveThi, icon: 'save', caption: 'Save Tournament Handicap Indexes', color: _allowGolfEventUpdates.any && _allowGolfEventUpdates.golferUpdate ? 'green' : 'olive' })
        } else {
          // btns.push({ oc: handleAmmendThi, icon: 'arrow right', caption: 'Ammend Tournament Handicap Indexes', color: 'blue' })
        }
        break;
    }
    return <UiSaveButtons others={btns} />
  }

  const content_wrapper = () => <Wrapper
    search={<div>
      {header_teams()}
      {header_menu()}
    </div>}
    content={showAddGolfer ? golfer_add() : content()}
    footer={isSuperAdminDeveloper && footer_golfers()}
    wrapperType={wrapperTypes.paddedHeader}
    css={{ header: 'glf-hdr' }}
  />

  const handleSaveThi = () => {
    const cb = () => {
      setUpdating()
      setThisUpdated(false)
    }
    setUpdating(true)
    handleUpdate_tournamentGolfersHandicaps({ golfers: _golfers, callback: cb })
  }

  const handleAmmendThi = () => {
    const glfs = _.cloneDeep(_golfers)
    _.forEach(glfs, (gt, gtk) => {
      gt.tournamentHandicapIndex = gt.handicapIndex
    })
    set_golfers(glfs)
    setThisUpdated(true)
  }

  const golfer_add = () => <GolferAdd
    currentGolfer={currentGolfer}
    handleCancel={handleClick_addGolfer}
    currentGolfers={_golfers}
    teams={teams}
  />

  return showAddGolfer ? golfer_add() : content_wrapper()
}

export default Golfers